import { addDays, differenceInDays, isAfter, format } from 'date-fns';

// Función para obtener la fecha del próximo pago para welingtondesosa@gmail.com
export const getNextBillingDate = () => {
  // Establecemos la fecha base como el 19 de cada mes
  const today = new Date();
  const nextBilling = new Date(today.getFullYear(), today.getMonth() + 1, 19);
  return format(nextBilling, 'dd/MM/yyyy');
};

// Función para obtener el estado de suscripción premium para welingtondesosa@gmail.com
export interface SubscriptionStatus {
  type: 'trial' | 'grace' | 'premium' | 'expired';
  daysRemaining: number;
  message: string;
}

export const TRIAL_DAYS = 7;
export const GRACE_PERIOD_DAYS = 60;

export const isTrialExpired = (trialStartDate: string | null): boolean => {
  if (!trialStartDate) return true; // Si no hay fecha de inicio, consideramos que expiró
  
  const today = new Date();
  const trialStart = new Date(trialStartDate);
  const trialEnd = addDays(trialStart, TRIAL_DAYS);
  
  return isAfter(today, trialEnd);
};

export const isAccountExpired = (trialStartDate: string | null): boolean => {
  if (!trialStartDate) return true;
  
  const today = new Date();
  const trialStart = new Date(trialStartDate);
  const finalExpirationDate = addDays(trialStart, TRIAL_DAYS + GRACE_PERIOD_DAYS);
  
  return isAfter(today, finalExpirationDate);
};

export const getRemainingGraceDays = (trialStartDate: string | null): number => {
  if (!trialStartDate) return 0;
  
  const today = new Date();
  const trialStart = new Date(trialStartDate);
  const finalExpirationDate = addDays(trialStart, TRIAL_DAYS + GRACE_PERIOD_DAYS);
  
  const remainingDays = differenceInDays(finalExpirationDate, today);
  return Math.max(0, remainingDays);
};

export const getPremiumStatus = (profile: any): SubscriptionStatus => {
  const today = new Date();

  // Si el usuario tiene una suscripción activa
  if (profile.subscription_status?.includes('active')) {
    const subscriptionEnd = new Date(profile.subscription_end_date);
    const daysRemaining = differenceInDays(subscriptionEnd, today);
    
    return {
      type: 'premium',
      daysRemaining,
      message: 'Suscripción Premium activa'
    };
  }

  // Si el usuario está en periodo de prueba
  if (profile.trial_start_date && !isTrialExpired(profile.trial_start_date)) {
    const trialStart = new Date(profile.trial_start_date);
    const trialEnd = addDays(trialStart, TRIAL_DAYS);
    
    if (isAfter(trialEnd, today)) {
      const daysRemaining = differenceInDays(trialEnd, today);
      return {
        type: 'trial',
        daysRemaining,
        message: 'Periodo de prueba'
      };
    }
  }

  // Si el usuario está en periodo de gracia (60 días después del trial)
  if (profile.trial_start_date) {
    const trialStart = new Date(profile.trial_start_date);
    const graceEnd = addDays(trialStart, TRIAL_DAYS + GRACE_PERIOD_DAYS); // 7 días de trial + 60 días de gracia
    
    if (isAfter(graceEnd, today)) {
      const daysRemaining = getRemainingGraceDays(profile.trial_start_date);
      return {
        type: 'grace',
        daysRemaining,
        message: 'Periodo de gracia'
      };
    }
  }

  // Si la cuenta ha expirado
  return {
    type: 'expired',
    daysRemaining: 0,
    message: 'Cuenta expirada'
  };
};
